/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  CreateFeeConfigOptions,
  CreateFeeConfigStatus201,
  CreateFeeConfigStatus400,
  CreateFeeConfigStatus409,
  CreateFeeConfigStatus500,
} from '../types/CreateFeeConfig'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { createFeeConfig } from '../clients/createFeeConfig'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const createFeeConfigMutationKey = () => [{ url: '/v1/fees/config' }] as const

export function createFeeConfigMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = createFeeConfigMutationKey()
  return mutationOptions<
    CreateFeeConfigStatus201,
    ResponseErrorConfig<
      CreateFeeConfigStatus400 | CreateFeeConfigStatus409 | CreateFeeConfigStatus500
    >,
    CreateFeeConfigOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ body }) => {
      return createFeeConfig({ ...config, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @description Admin only. Fails with 409 if the tier is already configured; use PUT to change an existing rate.
 * @summary Create the trading fee configuration of a tenant for a tier.
 * {@link /v1/fees/config}
 */
export function useCreateFeeConfig<TContext>(
  options: {
    mutation?: UseMutationOptions<
      CreateFeeConfigStatus201,
      ResponseErrorConfig<
        CreateFeeConfigStatus400 | CreateFeeConfigStatus409 | CreateFeeConfigStatus500
      >,
      CreateFeeConfigOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? createFeeConfigMutationKey()

  const baseOptions = createFeeConfigMutationOptions(config) as UseMutationOptions<
    CreateFeeConfigStatus201,
    ResponseErrorConfig<
      CreateFeeConfigStatus400 | CreateFeeConfigStatus409 | CreateFeeConfigStatus500
    >,
    CreateFeeConfigOptions,
    TContext
  >

  return useMutation<
    CreateFeeConfigStatus201,
    ResponseErrorConfig<
      CreateFeeConfigStatus400 | CreateFeeConfigStatus409 | CreateFeeConfigStatus500
    >,
    CreateFeeConfigOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    CreateFeeConfigStatus201,
    ResponseErrorConfig<
      CreateFeeConfigStatus400 | CreateFeeConfigStatus409 | CreateFeeConfigStatus500
    >,
    CreateFeeConfigOptions,
    TContext
  >
}
